import request from '@/utils/request'
import { API } from './apiConfig'

export function getSpeakerHome(data) {
	return request({
		method: 'get',
		url: API.getSpeakerHome,
		params: data
	})
}
export function getCourseSearchList(data) {
	return request({
		method: 'get',
		url: API.getCourseSearchList,
		params: data
	})
}
export function getTagList(data) {
	return request({
		method: 'get',
		url: API.getTagList,
	})
}
export function getSearchTagCourseList(data) {
	return request({
		method: 'get',
		url: API.getSearchTagCourseList,
		params: data
	})
}
export function getCourseDetail(data) {
	return request({
		method: 'get',
		url: API.getCourseDetail,
		params: data
	})
}
export function collectAdd(data) {
	return request({
		method: 'post',
		url: API.collectAdd,
		params: data
	})
}
export function cancelCollectAdd(data) {
	return request({
		method: 'post',
		url: API.cancelCollectAdd,
		params: data
	})
}
export function coursePlayUrl(data) {
	return request({
		method: 'get',
		url: API.coursePlayUrl,
		params: data
	})
}
export function saveViewTime(data) {
	return request({
		method: 'get',
		url: API.saveViewTime,
		params: data
	})
}
export function searchDoctorCourse(data) {
	return request({
		method: 'get',
		url: API.searchDoctorCourse,
		params: data
	})
}
export function focusSpeaker(data) {
	return request({
		method: 'get',
		url: API.focusSpeaker,
		params: data
	})
}
export function focusSpeakerList(data) {
	return request({
		method: 'get',
		url: API.focusSpeakerList,
		params: data
	})
}
export function collectSearchList(data) {
	return request({
		method: 'get',
		url: API.collectSearchList,
		params: data
	})
}
export function collectMeeting(data) {
	return request({
		method: 'get',
		url: API.IndexMeetingList,
		params: data
	})
}
export function collectQuestionnaire(data) {
	return request({
		method: 'get',
		url: API.IndexQuestionnaireList,
		params: data
	})
}
export function collectLiveWeb(data) {
	return request({
		method: 'get',
		url: API.getCouldLiveList,
		params: data
	})
}
export function specialSpeakerInfo(data) {
	return request({
		method: 'get',
		url: API.specialSpeakerInfo,
		params: data
	})
}
export function accountAll(data) {
	return request({
		method: 'get',
		url: API.accountAll,
		params: data
	})
}
export function beanAccount(data) {
	return request({
		method: 'get',
		url: API.beanAccount,
		params: data
	})
}
export function beanDetailList(data) {
	return request({
		method: 'get',
		url: API.beanDetailList,
		params: data
	})
}
export function speakerAccount(data) {
	return request({
		method: 'get',
		url: API.speakerAccount,
		params: data
	})
}
export function speakerDetailList(data) {
	return request({
		method: 'get',
		url: API.speakerDetailList,
		params: data
	})
}
export function canWithdrawAmount(data) {
	return request({
		method: 'get',
		url: API.canWithdrawAmount,
		params: data
	})
}
export function applyWithdraw(data) {
	return request({
		method: 'get',
		url: API.applyWithdraw,
		params: data
	})
}
// 支付流程
export function queryCourseFee(data) {
	return request({
		method: 'get',
		url: API.queryCourseFee,
		params: data
	})
}
export function submitOrder(data) {
	return request({
		method: 'post',
		url: API.submitOrder,
		data: data
	})
}
export function queryOrderBill(data) {
	return request({
		method: 'get',
		url: API.queryOrderBill,
		params: data
	})
}
export function knowledgeOrderPay(data) {
	return request({
		method: 'post',
		url: API.knowledgeOrderPay,
		params: data
	})
}
export function wechatPayResult(data) {
	return request({
		method: 'get',
		url: API.wechatPayResult,
		params: data
	})
}
export function getFunBeanList(data) {
	return request({
		method: 'get',
		url: API.getFunBeanList,
		params: data
	})
}
export function getRecommendedList(data) {
	return request({
		method: 'get',
		url: API.getRecommendedList,
		params: data
	})
}
export function getShareQrCode(data) {
	return request({
		method: 'get',
		url: API.getShareQrCode,
		params: data
	})
}
export function getInviteQrCode(data) {
	return request({
		method: 'get',
		url: API.getInviteQrCode,
		params: data
	})
}
export function shareCourse(data) {
	return request({
		method: 'get',
		url: API.shareCourse,
		params: data
	})
}
export function shareSpeaker(data) {
	return request({
		method: 'get',
		url: API.shareSpeaker,
		params: data
	})
}
export function getTaskFunBean(data) {
	return request({
		method: 'post',
		url: API.getTaskFunBean,
		params: data
	})
}
export function getFunBeanRuleList(data) {
	return request({
		method: 'get',
		url: API.getFunBeanRuleList,
		params: data
	})
}
export function getShareHandle(data) {
	return request({
		method: 'get',
		url: API.getShareHandle,
		params: data
	})
}

export function getSearchCourseList(data) {
	return request({
		method: 'get',
		url: API.getSearchCourseList,
		params: data
	})
}

export function getCollectStatus(data) {
	return request({
		method: 'get',
		url: API.getCollectStatus,
		params: data
	})
}

export function getRmbAccontInfo(data) {
	return request({
		method: 'get',
		url: API.getRmbAccontInfo,
		params: data
	})
}

export function getLiveSpeakerAmount(data) {
	return request({
		method: 'get',
		url: API.getLiveSpeakerAmount,
		params: data
	})
}

export function getLimitStatus(data) {
	return request({
		method: 'get',
		url: API.getLimitStatus,
		params: data
	})
}

export function getPurchasedRecommendedList(data) {
	return request({
		method: 'get',
		url: API.getPurchasedRecommendedList,
		params: data
	})
}

export function withdrawingAmount(data) {
	return request({
		method: "get",
		url: API.withdrawingAmount,
		params: data
	});
}
